module.exports = __webpack_public_path__ + "media/bg/quick_actions_bg-74fe98e9.jpg";